import { Controller } from "@hotwired/stimulus"

// Adds a 'fade-in' effect by toggling 'is-visible' when elements enter the viewport.
export default class extends Controller {
  static targets = ["item"]

  connect() {
    const options = { threshold: 0.08 }
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), options)
    this.itemTargets.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible')
        this.observer.unobserve(entry.target)
      }
    })
  }
}
